module.exports = __webpack_public_path__ + "leaves.844b062.png";